module.exports = __webpack_public_path__ + "static/media/Copperplate Gothic Light Regular.c6766763.svg";